import "./textArea.css.ts.vanilla.mjs";
var t = "p273__textArea-5010_b5cb233__96x9b11", _ = "p273__textArea-5010_b5cb233__96x9b10", r = "p273__textArea-5010_b5cb233__96x9b12";
export {
  t as textAreaDarkTheme,
  _ as textAreaLightTheme,
  r as textAreaStyle
};
//# sourceMappingURL=textArea.mjs.map
